import { render, staticRenderFns } from "./ChunkQuestions.vue?vue&type=template&id=b2284dd6"
import script from "./ChunkQuestions.vue?vue&type=script&lang=js"
export * from "./ChunkQuestions.vue?vue&type=script&lang=js"
import style0 from "./ChunkQuestions.vue?vue&type=style&index=0&id=b2284dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports